import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "./store";
import { postAPI } from "../service/http-service";
import { AuthApi } from "../auth/authEndpointConfig/AuthEndpointConfig";
import { LocalStorage } from "../util/Utils";

export interface LoginRequest {}

interface Franchisee {
  id: number | undefined;
  franchiseeName: string | undefined;
  loginTypeName: string | undefined;
  centerTypeName: string | undefined;
  feePerMonthWithTax: number | undefined;
  taxType: string | undefined;
  active: string | undefined;
  email: string | undefined;
  primaryMobileNumber: string | undefined;
  accountNumber: string | undefined;
  ifsc: string | undefined;
  bankName: string | undefined;
  royaltyPerMonthWithTax: number | undefined;
  royaltyPerMonthWithoutTax: number | undefined;
}

export interface LoginResponse {
  id: number | undefined;
  token: undefined;
  loginType: undefined;
  username: undefined;
  userId: undefined;
  productId: undefined;
  franchiseeId: undefined;
  userType: undefined | string;
  attendance: undefined | string;
  certificate: undefined | string;
  feePerMonthWithTax: number;
  franchisee: Franchisee;
  menus: any[] | null;
}

export interface LoginState {
  loading: boolean;
  loginResponse: LoginResponse;
  error: string | undefined;
}

const initialState: LoginState = {
  loading: false,
  error: undefined,
  loginResponse: {
    id: undefined,
    token: undefined,
    productId: undefined,
    loginType: undefined,
    username: undefined,
    userId: undefined,
    franchiseeId: undefined,
    userType: undefined,
    attendance: undefined,
    certificate: undefined,
    feePerMonthWithTax: 0,
    franchisee: {
      id: undefined,
      franchiseeName: undefined,
      loginTypeName: undefined,
      centerTypeName: undefined,
      feePerMonthWithTax: undefined,
      taxType: undefined,
      active: undefined,
      email: undefined,
      primaryMobileNumber: undefined,
      accountNumber: undefined,
      ifsc: undefined,
      bankName: undefined,
      royaltyPerMonthWithTax: undefined,
      royaltyPerMonthWithoutTax: undefined,
    },
    menus: null,
  },
};

export const loginAsync = createAsyncThunk(
  "auth/login",
  async (requestParam: any) => {
    try {
      const response = await postAPI(AuthApi.login, requestParam);
      return response;
    } catch (err) {
      return err;
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(loginAsync.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      loginAsync.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload: any = action.payload;
        if (payload?.status === 200) {
          state.loginResponse = payload.data.data as LoginResponse;
          LocalStorage.append(
            "loginResponse",
            payload.data.data as LoginResponse
          );
        } else {
          state.error =
            payload.errors && payload.errors.length > 0 && payload.errors[0];
        }
      }
    );
    builder.addCase(loginAsync.rejected, (state, action) => {
      state.loading = false;
      state.loginResponse.token = undefined;
      state.error = action.error.message;
    });
  },
});

export const loginSelector = (state: AppState) => state.login;
export const token = (state: AppState) => state.login.loginResponse.token;

const loginReducer = loginSlice.reducer;
export default loginReducer;
